function scrollToElement(elements, inverse=false, outer='main') {
    let $outer = $(outer)
    let viewportScroll = $outer.scrollTop();
    let viewportTop = $outer.offset().top;
    let found = false;
    elements.each((_, dt) => {
        if (found) return;
        let elementTop = $(dt).offset().top;
        if (((elementTop - 1) > viewportTop && !inverse) ||
                ((elementTop + 1) < viewportTop && inverse)) {
            found = true;
            $outer.animate({scrollTop: (viewportScroll + elementTop - viewportTop)}, 500);
        }
    });
}

export default function (id, _name, options) {
    let wrapper = options.wrapper || '.main-content__inner'
    let outer = options.outer || 'main'
    $(`#wrapper_${id}`).find('.scroll-holder.down').click(() => {
        scrollToElement($(wrapper), false, outer);
    });

    $(`#wrapper_${id}`).find('.scroll-holder.up').click(() => {
        scrollToElement($($(wrapper).get().reverse()), true, outer);
    });
}
